import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Seo from '../components/Seo';
import { Blocks, RichText } from '../components/RichText';
import { jobBySlug } from '../data/jobs';
import { jobJsonLd } from '../data/pageSchema';
import NotFoundPage from './NotFoundPage';
import './AreaPage.css';

const postJobPath = (user) => {
  if (!user) return '/signup';
  if (user.type === 'provider') return '/provider-dashboard';
  return '/customer-dashboard';
};

const JobPage = () => {
  const { slug } = useParams();
  const job = jobBySlug(slug);
  const { user } = useAuth();

  if (!job) return <NotFoundPage />;

  return (
    <div className="area-page">
      <Seo
        title={job.title}
        description={job.description}
        path={job.path}
        jsonLd={jobJsonLd(job)}
      />
      <header className="area-hero">
        <div className="hero-bg-lines" aria-hidden="true" />
        <div className="area-hero-content">
          <div className="hero-eyebrow">Swansea</div>
          <h1>{job.h1}</h1>
        </div>
      </header>
      <div className="page-wrapper">
        <section className="area-card area-block area-prose">
          <Blocks blocks={job.blocks} />
        </section>
        <section className="area-block" aria-labelledby="job-faq-heading">
          <h2 id="job-faq-heading">Questions</h2>
          <div className="area-faq">
            {job.faqs.map((faq) => (
              <details key={faq.q} className="area-faq-item">
                <summary>{faq.q}</summary>
                <div className="area-answer">
                  <p><RichText value={faq.a} /></p>
                </div>
              </details>
            ))}
          </div>
        </section>
        <section className="area-block">
          <h2>Related <span>pages</span></h2>
          <div className="area-nearby">
            {job.links.map((item) => (
              <Link key={item.href} to={item.href} className="area-chip">{item.label}</Link>
            ))}
          </div>
        </section>
        <section className="area-cta">
          <h2>Post a job <span>free</span></h2>
          <p>Posting does not book a van, and it does not mean anyone will send a price.</p>
          <div className="area-cta-actions">
            <Link to={postJobPath(user)} className="btn btn-primary">Post a job free</Link>
            <Link to="/areas/swansea" className="btn btn-secondary">Swansea</Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default JobPage;
